export const Image = ({ title, largeImage, smallImage, isRtl }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        {" "}
        <div className="hover-text">
          <h4
            style={{
              fontFamily: isRtl ? "amiriBold" : "Open Sans",
            }}
          >
            {title}
          </h4>
        </div>
        <img src={smallImage} className="img-responsive" alt={title} />{" "}
      </div>
    </div>
  );
};
